/* ============================================================
   KAFIE 1901 - v8 behaviour
   1. free-shipping meter (goal gradient) - reads the real cart
   2. add to bag from the grid and the compare table, no reload
   3. club picker maths - opens on 2 bags / every 4 weeks
   4. mobile nav drawer
   No dependencies. Safe to delete along with v8.css to revert.
   s41: per-cup pricing removed site-wide at Danny's request - the
   club cup-line no longer quotes cents a cup or the cafe price.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var money = function (cents, fmt) {
    var n = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, n)
                                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---------- 1 + 2. cart, meter, add to bag ---------- */
  var meter = document.querySelector('[data-k8-meter]');
  var fmt = meter ? meter.getAttribute('data-money-format') : '${{amount}}';
  var threshold = meter ? parseInt(meter.getAttribute('data-threshold'), 10) : 7500;

  /* s35: the headline STATES the offer, it no longer counts down to it.
     Danny asked for "free shipping in orders above ___", so the standing
     promise is the main line and the progress lives in the bar and the
     sub-line. Keep the threshold inside whatever sentence sits here -
     a free-shipping bar without its number is not a claim, it is a tease.
     This string must stay in step with the Liquid that renders the first
     paint in sections/v8-header.liquid, or the bar flickers to a
     different sentence the moment cart.js comes back. */
  function paint(cart) {
    var count = cart.item_count || 0;
    var total = cart.total_price || 0;
    document.querySelectorAll('[data-k8-count]').forEach(function (el) { el.textContent = count; });
    if (!meter) return;
    var left = Math.max(0, threshold - total);
    var bar = meter.querySelector('[data-k8-bar]');
    var txt = meter.querySelector('[data-k8-text]');
    var sub = meter.querySelector('[data-k8-sub]');
    if (bar) bar.style.width = Math.min(100, (total / threshold) * 100).toFixed(1) + '%';
    if (txt) {
      txt.innerHTML = left > 0
        ? 'Free shipping on orders above <b>' + money(threshold, fmt) + '</b>'
        : '<span class="done">Free shipping unlocked</span>';
    }
    if (sub) {
      sub.textContent = left > 0
        ? 'Bag ' + money(total, fmt) + ' of ' + money(threshold, fmt)
        : 'Bag ' + money(total, fmt);
    }
  }

  function refresh() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
                 { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-k8-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('disabled') || btn.classList.contains('is-out')) return;
    var id = btn.getAttribute('data-k8-add');
    var label = btn.innerHTML;
    btn.innerHTML = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () {
        btn.innerHTML = 'Added ✓';
        setTimeout(function () { btn.innerHTML = label; }, 1400);
      })
      .catch(function () { btn.innerHTML = label; });
  });

  if (meter) refresh();

  /* ---------- 3. club picker ---------- */
  var picker = document.querySelector('[data-k8-picker]');
  if (picker) {
    var base = parseFloat(picker.getAttribute('data-base')) || 17.99;
    var disc = (parseFloat(picker.getAttribute('data-discount')) || 10) / 100;
    var cups = parseInt(picker.getAttribute('data-cups'), 10) || 28;
    var n = parseInt(picker.getAttribute('data-start'), 10) || 2;
    var out = picker.querySelector('[data-k8-bags]');
    var freq = picker.querySelector('[data-k8-freq]');
    var totalEl = picker.querySelector('[data-k8-total]');
    var perEl = picker.querySelector('[data-k8-per]');
    var saveEl = picker.querySelector('[data-k8-save]');
    var cupEl = picker.querySelector('[data-k8-cupline]');
    var ctaEl = picker.querySelector('[data-k8-cta]');
    var termEl = picker.querySelector('[data-k8-terms]');
    var usd = function (v) { return '$' + v.toFixed(2); };

    function draw() {
      var weeks = freq ? parseInt(freq.value, 10) : 4;
      var per = base * (1 - disc);
      var tot = per * n;
      var saved = (base - per) * n;
      var totalCups = Math.round(cups * n);
      if (out) out.textContent = n;
      if (totalEl) totalEl.textContent = usd(tot);
      if (perEl) perEl.textContent = usd(per) + ' a bag · every ' + weeks + ' weeks';
      if (saveEl) saveEl.textContent = 'You save ' + usd(saved) + ' each delivery';
      if (cupEl) cupEl.textContent = n + (n === 1 ? ' bag' : ' bags') + ' — about ' + totalCups + ' cups.';
      if (ctaEl) ctaEl.textContent = 'Join the Coffee Club — ' + usd(tot) + ' every ' + weeks + ' weeks';
      if (termEl) termEl.textContent = 'You are charged ' + usd(tot) + ' for each delivery, every ' + weeks +
        ' weeks, until you cancel. Cancel in one click from your account — no phone call, no email.';
    }
    var minus = picker.querySelector('[data-k8-minus]');
    var plus = picker.querySelector('[data-k8-plus]');
    if (minus) minus.addEventListener('click', function () { n = Math.max(1, n - 1); draw(); });
    if (plus) plus.addEventListener('click', function () { n = Math.min(12, n + 1); draw(); });
    if (freq) freq.addEventListener('change', draw);
    draw();
  }

  /* ---------- 4. mobile drawer ---------- */
  var burger = document.querySelector('[data-k8-burger]');
  var drawer = document.querySelector('[data-k8-drawer]');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();
